import { styled, useTheme } from "@mui/material";
import {
  RequestType,
  requestTypeExtendedTranslation,
} from "../../../interfaces";

interface ContainerProps {
  background: string;
}

const Container = styled("div", {
  shouldForwardProp: (prop) => prop !== "background",
})<ContainerProps>(({ theme, background }) => ({
  color: theme.palette.background.paper,
  background,
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "15px",
  borderRadius: "24px",
  padding: "2px 8px",
}));

interface RequestTypeProps {
  type: RequestType;
}

export function RequestTypeChip({ type }: RequestTypeProps) {
  const theme = useTheme();
  return (
    <Container background={theme.palette.documentTypes[type]}>
      {requestTypeExtendedTranslation[type].toUpperCase()}
    </Container>
  );
}
